<template>
  <div>
    <a-card title="估时过少的任务" size="small" class="filter-data">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="over" :loading="loading" row-key="id" />
    </a-card>
    <br />
    <a-card title="估时过高的任务" size="small" class="filter-data">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="notFull" :loading="loading" row-key="id" />
    </a-card>
  </div>
</template>
<script>
import { faultLevels } from '@/utils/dictionary';
import { getOverTimeTask } from '@/api/data/quality';
const columns = [
  {
    width: 90,
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
    customRender: (_text, _row) => {
      return 'TS-' + _text;
    }
  },
  {
    ellipsis: true,
    title: '任务名称',
    dataIndex: 'name'
  },
  {
    width: 90,
    ellipsis: true,
    title: '负责人',
    dataIndex: 'handler_role'
  },
  {
    width: 90,
    ellipsis: true,
    title: '预估工时',
    dataIndex: 'point'
  },
  {
    width: 160,
    ellipsis: true,
    title: '迭代',
    key: 'version_name',
    dataIndex: 'version_name'
  },
  {
    width: 160,
    ellipsis: true,
    title: '实际开始时间',
    key: 'dev_start_time',
    dataIndex: 'dev_start_time'
  },
  {
    width: 160,
    ellipsis: true,
    align: 'center',
    title: '实际结束时间',
    key: 'dev_end_time',
    dataIndex: 'dev_end_time'
  },
  {
    width: 100,
    title: '实际消耗时间',
    key: 'real_spend_time',
    dataIndex: 'real_spend_time'
  },
  {
    width: 100,
    title: '估时浮动',
    key: 'time_float',
    dataIndex: 'time_float'
  }
];

export default {
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      expand: false,
      faultLevels,
      notFull: [],
      over: [],
      projects: [],
      tagData: [],
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      faultInfo: {},
      modalVisible: false,
      faultId: null,
      tableData: [],
      columns
    };
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  methods: {
    getDiagramData() {
      getOverTimeTask(this.filterForm).then(res => {
        this.over = res.data.over;
        this.notFull = res.data.not_full;
      });
    },

    onDetail(record) {
      this.$router.push({ name: 'page:event:fault:detail', query: { faultId: record.id }});
    },

    toggle() {
      this.expand = !this.expand;
    },

    reset() {
      this.filterForm = {
        version_id: 1,
        user_group: 1
      };
      this.getDiagramData();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
